import { render, staticRenderFns } from "./mold_wait.vue?vue&type=template&id=2b7568f5&scoped=true&"
import script from "./mold_wait.vue?vue&type=script&lang=js&"
export * from "./mold_wait.vue?vue&type=script&lang=js&"
import style0 from "./mold_wait.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mold_wait.vue?vue&type=style&index=1&id=2b7568f5&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7568f5",
  null
  
)

export default component.exports